import { reject } from "core-js/fn/promise";

// FIREBASE
const firebase = require("firebase");
require("firebase/firestore");
var db = firebase.firestore();

function setSubCollection(
  table,
  subTable,
  data,
  id,
  lastData = null,
  idSubCollection = null,
  thisTransfert = null
) {
  if (idSubCollection == null) {
    db.collection(table)
      .doc(id)
      .collection(subTable)
      .add(data)
      .then(function(docRef) {
        let idUpdate = docRef.id;
        data.id = idUpdate;
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
      .finally(() => {
        db.collection(table)
          .doc(id)
          .collection(subTable)
          .doc(data.id)
          .update(data);
        if (
          table == "customers" &&
          subTable == "storage" &&
          data.type == "folder"
        ) {
          thisTransfert.$router.push({
            path: "/back/document-management/",
            params: {
              idFolder: data.id,
            },
          });
        }
      });
  } else {
    db.collection(table)
      .doc(id)
      .collection(subTable)
      .doc(idSubCollection)
      .update(data)
      .then(function(result) {
        return true;
      })
      .catch(function(error) {
        console.error(error);
      });
    if (lastData != null) {
      db.collection(table)
        .doc(id)
        .collection(subTable)
        .doc(idSubCollection)
        .collection("former")
        .doc()
        .set(lastData)
        .then(function(result) {
          return true;
        })
        .catch(function(error) {
          console.error(error);
        });
    }
  }
}

function setSub2Collection(
  collection,
  idCollection,
  subCollection,
  idSubCollection,
  sub2Collection,
  data,
  idSub2Collection = null,
  lastData = null,
  thisTransfert = null
) {
  if (idSub2Collection == null) {
    db.collection(collection)
      .doc(idCollection)
      .collection(subCollection)
      .doc(idSubCollection)
      .collection(sub2Collection)
      .add(data)
      .then(function(docRef) {
        let idUpdate = docRef.id;
        data.id = idUpdate;
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
      .finally(() => {
        db.collection(collection)
          .doc(idCollection)
          .collection(subCollection)
          .doc(idSubCollection)
          .collection(sub2Collection)
          .doc(data.id)
          .update(data);
        if (
          collection == "customers" &&
          subCollection == "sites" &&
          (sub2Collection == "pages" || sub2Collection == "articles")
        ) {
          localStorage.setItem("idPage", data.id);
          thisTransfert.$router.push({
            path: "/back/" + sub2Collection + "/editor",
          });
        }
      });
  } else {
    db.collection(collection)
      .doc(idCollection)
      .collection(subCollection)
      .doc(idSubCollection)
      .collection(sub2Collection)
      .doc(idSub2Collection)
      .update(data)
      .then(function(result) {
        return true;
      })
      .catch(function(error) {
        console.error(error);
      });
    if (lastData != null) {
      db.collection(collection)
        .doc(idCollection)
        .collection(subCollection)
        .doc(idSubCollection)
        .collection(sub2Collection)
        .doc(idSub2Collection)
        .collection("former")
        .doc()
        .set(lastData)
        .then(function(result) {
          return true;
        })
        .catch(function(error) {
          console.error(error);
        });
    }
  }
}

export {
  setSubCollection,
  setSub2Collection,
};
